"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PLAID_ANALYTICS_EVENT_PREFIX = exports.PlaidCompletionRedirectUri = exports.PlaidFlowEnum = void 0;
var PlaidFlowEnum;
(function (PlaidFlowEnum) {
    PlaidFlowEnum["CASHOUT"] = "CASHOUT";
    PlaidFlowEnum["INCOME_VERIFICATION"] = "INCOME_VERIFICATION";
    PlaidFlowEnum["ADVISOR_NETWORTH"] = "ADVISOR_NETWORTH";
    PlaidFlowEnum["ADVISOR_NETWORTH_RECONNECT"] = "ADVISOR_NETWORTH_RECONNECT";
    PlaidFlowEnum["ASSET_VERIFICATION"] = "ASSET_VERIFICATION";
    PlaidFlowEnum["ADD_DEPOSIT_FUNDS"] = "ADD_DEPOSIT_FUNDS";
    PlaidFlowEnum["AUTOPAY"] = "AUTOPAY";
})(PlaidFlowEnum || (exports.PlaidFlowEnum = PlaidFlowEnum = {}));
var PlaidCompletionRedirectUri;
(function (PlaidCompletionRedirectUri) {
    PlaidCompletionRedirectUri["AVEN_MY_HOSTED_LINK_CONNECTION_COMPLETE"] = "aven-my://hosted-link-complete";
    PlaidCompletionRedirectUri["AVEN_ADVISOR_HOSTED_LINK_CONNECTION_COMPLETE"] = "aven-advisor://app/plaidLink";
})(PlaidCompletionRedirectUri || (exports.PlaidCompletionRedirectUri = PlaidCompletionRedirectUri = {}));
exports.PLAID_ANALYTICS_EVENT_PREFIX = 'plaid_internal_';
